import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UrlSerializer } from '@angular/router';
import { environment } from 'src/environments/environment';
import {
  LoggingService,
  LogSubscriberService,
  LogSubscription,
} from 'tr-library/logging';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LegacyLoaderComponent } from './modules/shared/components/legacy-loader/legacy-loader.component';
import { LowerCaseUrlSerializer } from './modules/shared/services/LowerCaseURLSerialzer';
import { PageNotFoundComponent } from './modules/shared/views/pagenotfound/pagenotfound.component';

registerLocaleData(localeDe, localeDeExtra);

@NgModule({
  declarations: [AppComponent, LegacyLoaderComponent, PageNotFoundComponent],
  imports: [BrowserAnimationsModule, AppRoutingModule, HttpClientModule],
  providers: [
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    { provide: LOCALE_ID, useValue: 'de' },
    LoggingService,
    LogSubscriberService,
    {
      provide: 'subscription',
      useValue: environment.apiReporting
        ? LogSubscription.Api
        : LogSubscription.Console,
    },
    { provide: 'sub_app', useValue: 'Tarifrechner' },
    { provide: 'src_url', useValue: environment.apiUrl },
    { provide: ErrorHandler, useClass: LoggingService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
